import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {withRouter} from 'react-router';
import {Redirect} from 'react-router-dom';
import lifecycle from 'recompose/lifecycle';
import setDisplayName from 'recompose/setDisplayName';
import {fetchUserProfileAction} from 'pages/Profile/actions';
import AppContext from 'pages/AppContext';

const mapStateToProps = state => ({
  userId: AppContext.persistentStore.getItem('userId'),
  accessToken: AppContext.persistentStore.getItem('cmsAccessToken'),
  user: state.userProfile.profile,
  fetching: state.userProfile.fetching
});

const mapDispatchToProps = {
  fetchUserProfile: fetchUserProfileAction
};

// HOC that prevents its wrapped component from rendering until a user profile has been loaded
export default Component => compose(
  setDisplayName('UserContext'),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      if (this.props.userId) {
        this.props.fetchUserProfile(this.props.userId);
      }
    }
  })
)(props => {
  if (!(props.accessToken && props.userId) && props.location.pathname !== '/login') {
    // we have either no userId or no accessToken in localStorage, so redirect the user to
    // to the login page if they're not already there.
    return <Redirect to='/login' />;
  } else if (props.user) {
    // user profile is loaded, everything is fine, proceed.
    return <Component {...props} />;
  } else {
    // we have accessToken and userId but not the profile, so render nothing for a second
    // while the user profile loads.
    return null;
  }
});



// WEBPACK FOOTER //
// ./public/hoc/UserContext.jsx